// Mirrors the backend's normalizeIndianPhone (libs/common/src/utils/phone.helper.ts):
// the login DB lookup is an exact string match against `phone`, which is always
// stored as +91XXXXXXXXXX. A bare 10-digit entry never matched until now — this
// normalizes on submit so "8971100269" and "+918971100269" both work.
export function normalizeIdentifier(raw: string): string {
  const value = raw.trim();
  if (value.includes('@')) return value;

  const digits = value.replace(/[^\d]/g, '');
  if (/^[6-9]\d{9}$/.test(digits)) return `+91${digits}`;
  if (/^91[6-9]\d{9}$/.test(digits)) return `+${digits}`;
  return value;
}

/** True while the identifier looks like an in-progress bare phone number (no
 *  '@', no manually-typed '+') — used to show a "+91" prefix hint as the user types. */
export function looksLikeBarePhone(value: string): boolean {
  return value.length > 0 && !value.includes('@') && !value.startsWith('+') && /^[0-9]+$/.test(value);
}
